import { render, staticRenderFns } from "./PricingList.vue?vue&type=template&id=29c1987a&"
import script from "./PricingList.vue?vue&type=script&lang=js&"
export * from "./PricingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports